import React from "react"
import { Button, Card, Table } from "antd"
import { ColumnsType } from "antd/lib/table"
import IVendor from "@domain/Vendor"
import { trans } from "@resources/localization"
import { useAppSelector } from "@hook/useAppSelector"
import { PAGINATION } from "@config/constant"
import { Link, useSearchParams } from "react-router-dom"
import { useAppDispatch } from "@hook/useAppDispatch"
import { changeAddVendorVisible } from "@reducer/vendor.reducer"
import SecurityService from "@util/SecurityService"
import { VENDOR_SCOPE } from "@config/permission"
import { find } from "lodash"
import { formatDateFull } from "@util/Common"
export const VendorTable: React.FC = () => {
    const dispatch = useAppDispatch()
    const size: number = useAppSelector((state) => state.vendor.pagination.size)
    const currentPage: number = useAppSelector((state) => state.vendor.pagination.currentPage)
    const total: number = useAppSelector((state) => state.vendor.pagination.total)
    const totalPage: number = useAppSelector((state) => state.vendor.pagination.totalPage)
    const listVendor = useAppSelector((state) => state.vendor.listVendor)
    const listCountry = useAppSelector((state) => state.vendor.listCountry)
    const [searchParams, setSearchParams] = useSearchParams()
    const loadingList = useAppSelector((state) => state.vendor.loadingListVendor)

    const columns: ColumnsType<IVendor> = [
        {
            title: trans("vendor.code"),
            className: "bold-400",
            dataIndex: "code",
            width: 100,
            fixed: "left",
            render: (code, vendor: IVendor) =>
                SecurityService.can(VENDOR_SCOPE.VENDOR_VIEW_DETAIL) ? <Link to={`/vendor/${vendor?.code}`}>{code}</Link> : <p>{code}</p>,
        },
        {
            title: trans("vendor.name"),
            className: "bold-400",
            dataIndex: "name",
            width: 150,
        },
        {
            title: trans("vendor.administrator"),
            className: "bold-400",
            dataIndex: "manager",
            width: 120,
        },
        {
            title: trans("vendor.country"),
            className: "bold-400",
            dataIndex: "countryCode",
            render: (countryCode: string) => find(listCountry, { code: countryCode })?.name,
            width: 120,
        },
        {
            title: trans("contact-detail.created_by"),
            className: "bold-400",
            dataIndex: "createdBy",
            width: 120,
        },
        {
            title: trans("vendor.created_at"),
            className: "bold-400",
            dataIndex: "createdAt",
            render: (date: string) => (date ? formatDateFull(date) : ""),
            width: 150,
        },
        {
            title: trans("Domain"),
            className: "bold-400",
            dataIndex: "vendorMapping",
            render: (vendorMapping: string) => {
                if (vendorMapping && Array.isArray(vendorMapping)) {
                    return vendorMapping?.map((el: { [key: string]: any }, index: number) => {
                        return (
                            <div key={index}>
                                <a
                                    href={`https://${el?.domain}`}
                                    target="_blank"
                                    rel="noreferrer">{`https://${el?.domain}`}</a>
                            </div>
                        )
                    })
                }
                return ""
            },
            width: 150,
        },
    ]
    const handleChangePage = (page: number, pageSize: number) => {
        const oldSearch = Object.fromEntries(searchParams.entries())
        const param: any = {
            ...oldSearch,
            page: !searchParams.has("size") || Number(oldSearch?.size) === pageSize ? page : PAGINATION.DEFAULT_CURRENT_PAGE,
            size: pageSize,
        }
        setSearchParams(param)
    }
    return (
        <Card
            className="space-layout"
            title={total !== 0 ? `${trans("contact.page")} ${currentPage}/${totalPage} (${total})` : ""}
            extra={
                SecurityService.can(VENDOR_SCOPE.VENDOR_CREATE) && (
                    <Button
                        type="primary"
                        onClick={() => {
                            dispatch(changeAddVendorVisible(true))
                        }}>
                        {trans("vendor.create")}
                    </Button>
                )
            }>
            <Table
                rowKey={"id"}
                columns={columns}
                scroll={{
                    x: true,
                }}
                dataSource={listVendor || []}
                loading={loadingList}
                className="bd-radius-5"
                locale={{
                    emptyText: trans("table.empty"),
                }}
                pagination={{
                    pageSize: size,
                    total: total,
                    current: currentPage,
                    pageSizeOptions: PAGINATION.DEFAULT_PAGE_SIZE_OPTIONS,
                    showSizeChanger: true,
                    onChange: handleChangePage,
                    locale: {
                        items_per_page: `/ ${trans("contact.page_change")}`,
                    },
                }}
            />
        </Card>
    )
}
